const multiClass = (classList: any) => classList.join(' ');

export { multiClass };
